// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2044 ? "891cff7f" : chunkId) + "." + {"2044":"0e03a858305ec56d","4185":"a2f4bdcbf5f1d924","7592":"482c547f56cb670e"}[chunkId] + ".js";
};